"use client"
/* */
const customPropertyPrefix = "$";

export { customPropertyPrefix };
//# sourceMappingURL=types.mjs.map
